import { render, staticRenderFns } from "./SubscribeBonuses.vue?vue&type=template&id=f5861a5c&"
import script from "./SubscribeBonuses.vue?vue&type=script&lang=js&"
export * from "./SubscribeBonuses.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports